var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-con-loading__container",attrs:{"id":"todo-app"}},[_c('vs-row',{staticClass:"m-0 p-0",attrs:{"vs-align":"center","vs-type":"flex","vs-justify":"center","vs-w":"12"}},[_c('vs-col',{staticClass:"m-0 p-0",attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"9"}},[_c('Container')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }